export const ListProviderGiftCards = [
  { code: "01", name: "Bonus", taux: 10 },
  { code: "02", name: "Joker", taux: 10 },
  { code: "03", name: "ServiMax", taux: 10 },
  { code: "04", name: "Pluxee", taux: 10 },
  { code: "05", name: "TopChecks", taux: 10 },
];

export const ListticketType = [
  { code: "20", name: "Chèque Cadeau" },
  { code: "10", name: "Chèque Restaurant" },
  { code: "40", name: "Chèque Habillement " },
];
